import { render, staticRenderFns } from "./VikingSnakeGame.vue?vue&type=template&id=616f57d4&scoped=true&"
import script from "./VikingSnakeGame.vue?vue&type=script&lang=js&"
export * from "./VikingSnakeGame.vue?vue&type=script&lang=js&"
import style0 from "./VikingSnakeGame.vue?vue&type=style&index=0&id=616f57d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616f57d4",
  null
  
)

export default component.exports